import {
  FEEDBACK_RELATIONSHIP,
  FEEDBACK_RELATIONSHIP_ALIAS,
} from 'domain/people/employee/Timeline/feedback/form/FeedbackRelationshipDropdown';
import { DateField } from 'framework/ui/field';
import FeedbackInappropriateReason from 'domain/people/employee/Timeline/feedback/shared/button/FeedbackInappropriateReason';
import { READ_EMPLOYEE_TIMELINE } from 'domain/shared/employee';
import { useAuthorization } from 'framework/authorization';
import { FEEDBACKS_I_SENT } from 'domain/people/employeePortal/feedback/useSentFeedbacksService';
import { Box, Typography } from '@mui/material';

import type { Data } from 'framework/types';
import {
  feedbackTimelineFooterSx,
  timelineAdditionalSx,
} from 'domain/shared/timeline/layout/BaseTimelineRecordLayout/baseTimelineRecordSx';

const FeedbackFooter = ({ entity, noTopIndent, isFeedbackAboutMeTab = false }: Data) => {
  const relatedPeriodStart = entity.getValueBySource('relatedPeriodStart');
  const relatedPeriodEnd = entity.getValueBySource('relatedPeriodEnd');
  const relationship = entity.getValueBySource('relationship');
  const relatedClient = entity.getValueBySource('relatedClient');
  const relatedProject = entity.getValueBySource('relatedProject');
  const isSharedWithEmployee = entity.getValueBySource('isSharedWithEmployee');
  const prefersPersonalDelivery = entity.getValueBySource('prefersPersonalDelivery');
  const needsHelp = entity.getValueBySource('needsHelp');
  const discussedWithColleague = entity.getValueBySource('discussedWithColleague');

  const { isGranted } = useAuthorization();

  let additionalInfo;

  if (
    !relatedPeriodStart &&
    !relatedPeriodEnd &&
    (!relationship || relationship === FEEDBACK_RELATIONSHIP_ALIAS.NO_RELATION) &&
    !relatedClient &&
    !relatedProject
  ) {
    additionalInfo = null;
  } else {
    additionalInfo = (
      <Box data-testid="timeline-additional" sx={timelineAdditionalSx}>
        {relatedPeriodStart && relatedPeriodEnd && (
          <Box display="flex">
            <Typography component="span" variant="body1">
              Related period:&nbsp;
            </Typography>
            <DateField value={relatedPeriodStart} />
            &nbsp;-&nbsp;
            <DateField value={relatedPeriodEnd} />
          </Box>
        )}
        {relationship && relationship !== FEEDBACK_RELATIONSHIP_ALIAS.NO_RELATION && (
          <Typography>
            <Typography component="span" variant="body1">
              Relationship:{' '}
            </Typography>
            {FEEDBACK_RELATIONSHIP[relationship]}
          </Typography>
        )}
        {relatedClient && (
          <Typography>
            <Typography component="span" variant="body1">
              Related client:{' '}
            </Typography>
            {relatedClient}
          </Typography>
        )}
        {relatedProject && (
          <Typography>
            <Typography component="span" variant="body1">
              Related project:{' '}
            </Typography>
            {relatedProject}
          </Typography>
        )}
        {!isFeedbackAboutMeTab && (isGranted(READ_EMPLOYEE_TIMELINE) || isGranted(FEEDBACKS_I_SENT)) ? (
          <>
            <Typography>
              <Typography component="span" variant="body1">
                Feedback is shared with worker:{' '}
              </Typography>
              {isSharedWithEmployee ? 'Yes' : 'No'}
            </Typography>
            <Typography>
              <Typography component="span" variant="body1">
                Prefers Personal Delivery:{' '}
              </Typography>
              {prefersPersonalDelivery ? 'Yes' : 'No'}
            </Typography>
            <Typography>
              <Typography component="span" variant="body1">
                Needs Help:{' '}
              </Typography>
              {needsHelp ? 'Yes' : 'No'}
            </Typography>
            <Typography>
              <Typography component="span" variant="body1">
                Discussed With Colleague:{' '}
              </Typography>
              {discussedWithColleague ? 'Yes' : 'No'}
            </Typography>
          </>
        ) : null}
      </Box>
    );
  }

  return (
    <>
      {additionalInfo}
      <Box mt="0.75rem" sx={feedbackTimelineFooterSx}>
        <FeedbackInappropriateReason entity={entity} />
      </Box>
    </>
  );
};

export default FeedbackFooter;
